import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aa089ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLAdditionalService" }
const _hoisted_2 = { class: "additional__header bg-gray-200" }
const _hoisted_3 = { class: "additional__title" }
const _hoisted_4 = { class: "service__field border-l border-r border-t border-gray-200" }
const _hoisted_5 = { class: "field__placeholder" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__value" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-green-500" })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Количество", -1))
const _hoisted_9 = { class: "field__value" }
const _hoisted_10 = {
  key: 0,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Продолжительность (себестоимость)", -1))
const _hoisted_12 = { class: "field__value" }
const _hoisted_13 = {
  key: 1,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Продолжительность (клиенту)", -1))
const _hoisted_15 = { class: "field__value" }
const _hoisted_16 = {
  key: 2,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Себестоимость за час", -1))
const _hoisted_18 = { class: "field__value" }
const _hoisted_19 = {
  key: 3,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Выставление клиенту за час", -1))
const _hoisted_21 = { class: "field__value" }
const _hoisted_22 = {
  key: 4,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Общая себестоимость", -1))
const _hoisted_24 = { class: "field__value" }
const _hoisted_25 = {
  key: 5,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Общая сумма к оплате", -1))
const _hoisted_27 = { class: "field__value" }
const _hoisted_28 = {
  key: 6,
  class: "service__field border-l border-r border-gray-200"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Перевозчик", -1))
const _hoisted_30 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, " Дополнительные услуги (" + _toDisplayString(_ctx.additionalService.length) + ") ", 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalService, (service, j) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "additional__service",
        key: `waypoint-service-${j}`
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["service__container", { 'border-b': j === _ctx.additionalService.length - 1 }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(j + 1) + ". " + _toDisplayString(service.type_name), 1),
            _hoisted_6
          ]),
          (service.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(service.value || '-'), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.short)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (service.duration)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, _toDisplayString(service.duration || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (service.duration_client)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, _toDisplayString(service.duration_client || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (service.cost_per_hour)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatAmount(service.cost_per_hour)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (service.paid_price_per_hour)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatAmount(service.paid_price_per_hour)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (service.cost_total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatAmount(service.cost_total)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (service.paid_price_total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatAmount(service.paid_price_total)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (service.carrier_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, _toDisplayString(service.carrier_name || '-'), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    }), 128))
  ]))
}